import type { ReactElement } from 'react';
import React, { useState, useEffect } from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { t } from 'Src/i18n';
import { DropDownSimplified } from 'Components/frameworks/drop-down-simplified/DropDownSimplified';
import { Layer } from 'Components/frameworks/layer/Layer';
type Props = {
  toggleEditCriteria?: (isExpanded: boolean) => void;
  cancelEditCriteria?: () => void;
  children: (toggleExpanded: () => void, isExpanded: boolean) => ReactElement;
  renderCriteriaButton: (toggleExpanded: () => void, isExpanded: boolean) => ReactElement;
  title?: string;
  openByDefault?: boolean;
  dataTestId?: string;
};
export function CriteriaFieldDropDownWrapper({
  children,
  renderCriteriaButton,
  title,
  cancelEditCriteria,
  openByDefault = false,
  toggleEditCriteria,
  dataTestId = '',
}: Props) {
  const [isExpanded, setIsExpanded] = useState<boolean>(openByDefault);
  const { isTablet } = useResponsive();
  useEffect(() => {
    if (isExpanded !== openByDefault) {
      setIsExpanded(openByDefault);
    }
  }, [openByDefault]);

  const toggleExpanded = () => {
    toggleEditCriteria && toggleEditCriteria(isExpanded);
    setIsExpanded(!isExpanded);
  };

  const onCancel = () => {
    cancelEditCriteria && cancelEditCriteria();
    toggleExpanded();
  };

  if (isTablet) {
    return (
      <DropDownSimplified
        isExpanded={isExpanded}
        onClose={onCancel}
        renderTrigger={renderCriteriaButton}
        toggleExpansion={toggleExpanded}
        theme="hollow"
      >
        {children}
      </DropDownSimplified>
    );
  }

  return (
    <div data-testid={dataTestId}>
      {renderCriteriaButton(toggleExpanded, true)}
      {isExpanded ? (
        <Layer
          ariaLabel={title}
          buttonLeft={{
            iconName: ICONS.ARROW_TAIL_LEFT,
            label: t('common.backNavigation'),
            onClick: onCancel,
          }}
          closeLabel={t('common.close')}
          className="z-4"
          hasAnimateEnter
          onClose={onCancel}
        >
          <div className="flex flex-col">{children(toggleExpanded, isExpanded)}</div>
        </Layer>
      ) : null}
    </div>
  );
}
